import { AdminLayout } from '@/components/layouts'
import { SurveyForm } from './SurveyForm'

interface Community {
  id: number
  name: string
}

interface NewProps {
  communities: Community[]
  suggested_start_date: string
}

export default function New({ communities, suggested_start_date }: NewProps) {
  return (
    <AdminLayout
      title="Nouveau Sondage"
      breadcrumbs={[
        { label: 'Sondages', href: '/admin/surveys' },
        { label: 'Nouveau Sondage' }
      ]}
    >
      <div className="max-w-3xl">
        <SurveyForm
          communities={communities}
          suggestedStartDate={suggested_start_date}
          onSubmit="/admin/surveys"
        />
      </div>
    </AdminLayout>
  )
}
